// @import types
import { IHttpResponse } from 'app_types/httpTypes'
// @end

// @add your types
export enum PostLocations {
  STUDENT = 'student',
  TEACHER = 'teacher',
  ACCOUNT_EXECUTIVE = 'account_executive',
  COMPANY = 'company',
}

export interface IPost {
  _id: string,
  title: string,
  subtitle: string,
  tags: Array<any>
  postType: {
    _id: string,
    name: string
  },
  postDate: string
  eventDate: string
  locations: Array<any>
  isActive: boolean,
  coverUrl: string,
  content: any,
  authors: Array<any>
  cover_caption?: string
  additional_info?: {
    date?: string;
    country?: string;
    location?: string;
    schedule?: string;
    modality?: string;
  };
  brochureUrl?: string;
  slug?: string;
}

export interface IPostCategories extends IHttpResponse {
  categories: Array<{_id: string, name: string}>
}


export interface IFetchPosts extends IHttpResponse {
  posts: Array<IPost>,
  nPerPage: number,
  pageNumber: number,
  total_register: number
}
export interface IFetchPost extends IHttpResponse {
  post: IPost,
}
//@end
